import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { matchRequest } from "./utils";

const initialState: State = [];

function handleRequest(
  state: State,
  request: Boundaries["adjustWorkload"]["request"],
): State {
  const { resourceId, projectId, from, to, granularity } = request;
  const index = state.findIndex((req) =>
    matchRequest(req, resourceId, projectId, from, to, granularity),
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          adjustment: request,
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { adjustment: request, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { request }: Boundaries["adjustWorkload"]["success"],
): State {
  const { resourceId, projectId, from, to, granularity } = request;
  const index = state.findIndex((req) =>
    matchRequest(req, resourceId, projectId, from, to, granularity),
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          adjustment: request,
          request: setRequestStateToSuccess(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { adjustment: request, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { request }: Boundaries["adjustWorkload"]["failure"],
): State {
  const { resourceId, projectId, from, to, granularity } = request;
  const index = state.findIndex((req) =>
    matchRequest(req, resourceId, projectId, from, to, granularity),
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          adjustment: request,
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { adjustment: request, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.adjustWorkloadRequested]: handleRequest,
  [events.adjustWorkloadSucceeded]: handleSuccess,
  [events.adjustWorkloadFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
